import jquery from 'jquery';
import easing from 'jquery-easing';

import Site from './js/Site.js';

window.$ = window.jQuery = jquery;

$(document).ready(function() {
	new Site();
});


/** WEBPACK FOOTER **
 ** ./src/main.js
 **/